var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"banner-box"},[_c('el-carousel',{attrs:{"height":"431px","autoplay":true}},_vm._l((_vm.imgUrls),function(item){return _c('el-carousel-item',{key:item.id},[_c('a',{attrs:{"href":item.jump_url}},[_c('img',{attrs:{"src":item.img_url,"alt":""}})])])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }